import { IconProps } from '@/components/Icons'
import BaseSvg from '@/components/Icons/BaseSvg'

const DefaultExpanded = ({ title = 'Default Expanded', ...rest }: IconProps) => (
  <BaseSvg viewBox="0 0 191 191" title={title} {...rest}>
    <g id="layout-options-explorations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="tooltip-future" transform="translate(-540.000000, -122.000000)">
        <g id="Expandable-(default)" transform="translate(540.000000, 96.000000)">
          <g id="visual_expandable_default" transform="translate(0.000000, 26.000000)">
            <rect id="Rectangle" fill="#D8D8D8" x="0" y="0" width="191" height="191"></rect>
            <rect id="Rectangle" fill="#9F9F9F" x="0" y="16" width="14" height="175"></rect>
            <rect id="Rectangle-Copy" fill="#806BF2" x="76" y="16" width="109" height="175"></rect>
            <rect id="Rectangle-Copy-3" fill="#828282" x="14" y="16" width="62" height="175"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="20" y="4" width="105" height="6" rx="1.5"></rect>
            <circle id="Oval-Copy" fill="#8D8D8D" cx="5" cy="7" r="3"></circle>
            <circle id="Oval-Copy-2" fill="#8D8D8D" cx="13" cy="7" r="3"></circle>
            <g
              id="arrows"
              opacity="0.400000006"
              transform="translate(77.000000, 93.000000)"
              stroke="#FFFFFF"
              strokeLinecap="square"
            >
              <polyline id="Line-2" points="6 0 0 6.07750019 6 12"></polyline>
              <polyline id="Line-2-Copy" points="100 0 105 6.08215924 100 12"></polyline>
              <line x1="105.005952" y1="6" x2="4.5" y2="5.5" id="Line-3"></line>
            </g>
            <g id="arrows-copy" transform="translate(77.000000, 63.000000)" stroke="#FFFFFF" strokeLinecap="square">
              <polyline id="Line-2-Copy" points="100 0 105 6.08215924 100 12"></polyline>
              <line x1="105.005952" y1="6" x2="4.5" y2="5.5" id="Line-3"></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvg>
)

DefaultExpanded.displayName = 'DefaultExpanded'
export default DefaultExpanded
